import { PlatformEnum } from 'src/app/utils/platform.utils';

export type MSDeviceInfo = {
  uuid: string;
  platform: PlatformEnum;
  version: string;
  model: string;
  manufacturer: string;
  isVirtual: boolean;
};

export function mapDeviceInfoPlatformToMSPlatform(platform: string): PlatformEnum {
  switch (platform) {
    case 'ios':
      return PlatformEnum.IOS;
    case 'android':
      return PlatformEnum.ANDROID;
    default:
      return PlatformEnum.BROWSER;
  }
}
